import React, { useEffect, useState } from 'react';

const isErpSpaShell = (html) =>
  html.includes('id="root"') && html.includes('/static/js/main');

/**
 * 앱·브라우저에서 /kb_agreement.html 등이 ERP index.html(SPA)로 열릴 때
 * 로그인 리다이렉트 없이 정적 HTML 본문을 표시합니다.
 */
const StaticHtmlPage = ({ documentPath, title = '문서' }) => {
  const [html, setHtml] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = `${documentPath}?_=${Date.now()}`;

    fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        return res.text();
      })
      .then((text) => {
        if (isErpSpaShell(text)) {
          throw new Error('spa');
        }
        setHtml(text);
      })
      .catch(() => {
        setError('문서를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
      })
      .finally(() => setLoading(false));
  }, [documentPath]);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontFamily: 'sans-serif',
        }}
      >
        불러오는 중…
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          padding: 24,
          fontFamily: 'sans-serif',
          lineHeight: 1.6,
        }}
      >
        <p>{error}</p>
      </div>
    );
  }

  return (
    <iframe
      title={title}
      srcDoc={html}
      style={{
        display: 'block',
        width: '100%',
        height: '100vh',
        border: 'none',
      }}
    />
  );
};

export default StaticHtmlPage;
